/*Lazy youtube*/
(function () {
    var youtube = document.querySelectorAll(".lazy-youtube");
    for (var i = 0; i < youtube.length; i++) {
        var source =
            "https://img.youtube.com/vi/" +
            youtube[i].dataset.embed +
            "/sddefault.jpg";
        var image = new Image();
        image.setAttribute("class", "lazy");
        image.setAttribute("src", source);
        image.setAttribute("alt", "Youtube video");
        image.addEventListener(
            "load",
            (function () {
                youtube[i].appendChild(image);
            })(i)
        );
        youtube[i].addEventListener("click", function () {
            var iframe = document.createElement("iframe");
            iframe.setAttribute("frameborder", "0");
            iframe.setAttribute("allowfullscreen", "");
            iframe.setAttribute(
                "src",
                "https://www.youtube.com/embed/" +
                this.dataset.embed +
                "?rel=0&showinfo=0&autoplay=1"
            );
            this.innerHTML = "";
            this.appendChild(iframe);
        });
    }
})();



/*Product Tabs*/
function OpenSizeModal(){
    setTimeout(function(){
        document.querySelectorAll('.tool-tip-trigger__title')[0].click();
    }, 100);

}

function OpenSpecsModal(){
    setTimeout(function(){
        document.querySelectorAll('.specs-modal')[0].click();
    }, 100);

}

document.querySelectorAll(".filters .item").forEach(function (tab, index) {
    tab.addEventListener("click", function () {
        const filters = document.querySelectorAll(".filters .item");
        const tabs = document.querySelectorAll(".tabs__list .tab");

        filters.forEach(function (tab) {
            tab.classList.remove("active");
        });
        this.classList.add("active");

        tabs.forEach(function (tabContent) {
            tabContent.classList.remove("active");
        });
        tabs[index].classList.add("active");
    });
});



document.querySelectorAll('a[href="#openchat"]').forEach(link => {
  link.addEventListener('click', event => {
    const chatButton = document.getElementById('commslayer-widget-toggle');
    if (chatButton) {
      chatButton.click();
    } else {
      console.warn('Chat toggle button not found.');
    }
  });
});

// ==============================================
// BROOKLYN BICYCLE CO. - PDP FIXES (v15)
// ==============================================

// Fix 1: Sync ALL [data-product-price] elements on variant change
document.addEventListener('variant:change', function(e) {
  var variant = e.detail.variant;
  if (!variant) return;
  var price = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);
  document.querySelectorAll('[data-product-price]').forEach(function(el) {
    el.innerHTML = price;
  });
});

// Fix 3 (v15): Place Shop Pay installments under the price on BOTH desktop and mobile.
// Desktop target: inside .price-wrap-0to, AFTER the desktop price block
// Mobile target: inside the mobile price block, AFTER the mobile prices
(function() {
  function placeShopPayTerms() {
    var terms = document.querySelector('.shopify-payment-terms shopify-payment-terms')
             || document.querySelector('shopify-payment-terms');
    if (!terms) return;
    var wrapper = terms.closest('.get-it.shopify-payment-terms') || terms;

    var isMobile = window.innerWidth < 769;

    if (isMobile) {
      var mobilePriceBlock = document.querySelector(
        '.hide-on-desktop.pdp-title-container[data-product-blocks] .product-block--price'
      );
      if (mobilePriceBlock && wrapper.parentElement !== mobilePriceBlock) {
        mobilePriceBlock.appendChild(wrapper);
      }
    } else {
      // Desktop: append into .price-wrap-0to so Shop Pay sits under the prices
      var priceWrap = document.querySelector('.product-single__meta .price-wrap-0to');
      if (priceWrap && wrapper.parentElement !== priceWrap) {
        priceWrap.appendChild(wrapper);
      }
    }
  }

  document.addEventListener('DOMContentLoaded', placeShopPayTerms);
  window.addEventListener('resize', placeShopPayTerms);
  setTimeout(placeShopPayTerms, 500);
  setTimeout(placeShopPayTerms, 1500);
})();


// ==============================================
// v19 (2026-04-23): Move Judge.me stars INTO .price-wrap-0to on desktop
// so the price row renders as [compare][sale][savings] | [stars] and Shop Pay drops below.
// Mobile untouched (v15 mobile logic preserved below).
// ==============================================
(function() {
  function placeStarsInPriceRow() {
    var isDesktop = window.innerWidth >= 721;
    var stars = document.querySelector('.product-single__meta .product-block--header .pdp-test-v2.pdp-test-hide-on-mobile');
    var priceWrap = document.querySelector('.product-single__meta .price-wrap-0to');
    if (!stars || !priceWrap) return;
    if (isDesktop) {
      if (stars.parentElement !== priceWrap) {
        priceWrap.appendChild(stars);
      }
    } else {
      // Mobile: leave stars where theme puts them; do nothing
    }
  }
  document.addEventListener('DOMContentLoaded', placeStarsInPriceRow);
  window.addEventListener('resize', placeStarsInPriceRow);
  setTimeout(placeStarsInPriceRow, 300);
  setTimeout(placeStarsInPriceRow, 1200);
})();

/* FIX: Neutralize Visually AB Testing scroll-lock on homepage. */
(function() {
    function fixBodyOverflow() {
        var s = document.body.style;
        if (s.getPropertyValue("overflow-y") === "scroll" ||
            s.getPropertyValue("overflow") !== "") {
            s.setProperty("overflow-y", "auto", "important");
            s.setProperty("height", "auto", "important");
            }
    }
    fixBodyOverflow();
    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(m) {
            if (m.attributeName === "style") fixBodyOverflow();
        });
    });
    observer.observe(document.body, { attributes: true, attributeFilter: ["style"] });
})();


/* v21 PDP star reparent - desktop only */
(function(){
  function isDesktop(){ return window.matchMedia('(min-width: 721px)').matches; }
  function run(){
    try {
      if (!isDesktop()) return;
      var meta = document.querySelector('.product-single__meta [data-product-blocks]') ||
                 document.querySelector('.product-single__meta');
      if (!meta) return;
      var priceWrap = meta.querySelector('.price-wrap-0to');
      if (!priceWrap) return;
      // stars wrapper sits inside the product-block--header as pdp-test-v2.pdp-test-hide-on-mobile
      var candidates = meta.querySelectorAll('.pdp-test-v2.pdp-test-hide-on-mobile');
      var stars = null;
      candidates.forEach(function(el){
        if (el.classList.contains('product-block--price')) return; // skip price block
        if (el.querySelector('.jdgm-widget, .jdgm-prev-badge, [class*="jdgm-"]')) stars = el;
      });
      if (!stars) return;
      if (stars.parentElement === priceWrap) return; // already moved
      stars.setAttribute('data-v21-reparented','1');
      priceWrap.appendChild(stars);
    } catch(e) { /* noop */ }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  // Re-run after Judge.me / Shopify blocks inject async
  setTimeout(run, 400);
  setTimeout(run, 1200);
  setTimeout(run, 2500);
  window.addEventListener('resize', function(){
    // If user crosses breakpoint, undo or redo
    if (!isDesktop()) {
      var moved = document.querySelector('.price-wrap-0to > [data-v21-reparented="1"]');
      if (moved) {
        // put it back into header if possible
        var header = document.querySelector('.product-single__meta .product-block.product-block--header');
        if (header) header.appendChild(moved);
      }
    } else {
      run();
    }
  });
})();
/* end v21 reparent */

